import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9010Component } from './kymw9010.component';
import { GetAssociatedCompanyListService } from './api-service/get-associated-company-list.service';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

/**
 * ユーザ情報詳細画面 モジュール設定クラス
 *
 * @export KYMW9010Module
 * @class KYMW9010Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [
    KYMW9010Component,
  ],
  providers: [
    GetAssociatedCompanyListService,
  ],
})
export class KYMW9010Module {

}